import {Item} from '@radix-ui/react-radio-group';

import {style} from '../style';

import type {RadioGroupItemProps} from '@radix-ui/react-radio-group';

type Props = Omit<RadioGroupItemProps, 'children'> &
  React.RefAttributes<HTMLButtonElement> & {
    name: string;
    description?: string;
  };
export function StackedRadioGroupItem({
  name,
  description,
  className,
  ...props
}: Props): React.JSX.Element {
  return (
    <Item {...props} className={style.item}>
      <span
        aria-hidden="true"
        className="mt-1.5 flex h-4 w-4 shrink-0 cursor-pointer items-center justify-center rounded-full border border-slate6 bg-slate1 group-focus:ring-2 group-focus:ring-blue10 group-focus:ring-offset-2 group-radix-state-checked:border-transparent group-radix-state-checked:bg-blue10"
      >
        <span className="h-1.5 w-1.5 rounded-full bg-slate1" />
      </span>

      <span className={style.textWrapper}>
        <span className={style.name}>{name}</span>
        {description && (
          <span className={style.description}>{description}</span>
        )}
      </span>
    </Item>
  );
}

StackedRadioGroupItem.displayName = 'StackedRadioGroupItem';
